/*
 * @Author: songjingyang songjingyang@meishubao.com
 * @Date: 2025-03-28 15:40:04
 * @LastEditors: songjingyang songjingyang@meishubao.com
 * @LastEditTime: 2025-08-14 11:12:55
 * @FilePath: src/api/organization/index.ts
 * @Description: TypeScript版本 - 自动转换
 */

import request from '@/utils/request'

// 查询机构列表
export function listOrganization(query: any): any {
  return request({
    url: '/system/organization/list',
    method: 'get',
    params: query,
  })
}
// 查询机构密码
export function showPasswordFn(id: any): any {
  return request({
    url: `/system/organization/showPassword/${id}`,
    method: 'get',
  })
}

// 查询机构详细
export function getOrganization(id: any): any {
  return request({
    url: '/system/organization/' + id,
    method: 'get',
  })
}

// 新增机构
export function addOrganization(data: any): any {
  return request({
    url: '/system/organization',
    method: 'post',
    data: data,
  })
}
//  添加算力
export function addCompute(data: any): any {
  return request({
    url: '/org/compute/add',
    method: 'post',
    data: data,
  })
}

// 修改机构
export function updateOrganization(data: any): any {
  return request({
    url: '/system/organization',
    method: 'put',
    data: data,
  })
}
export function updatePwd(data: any): any {
  return request({
    url: '/system/organization/updatePwd',
    method: 'post',
    params: data,
  })
}

// 删除机构
export function delOrganization(id: any): any {
  return request({
    url: '/system/organization/' + id,
    method: 'delete',
  })
}

// 查询算力消耗明细
export function getComputePowerConsumption(query: any): any {
  return request({
    url: '/org/compute/consume/list',
    method: 'get',
    params: query,
  })
}

// 查询算力增加明细
export function getComputePowerGain(query: any): any {
  return request({
    url: '/org/compute/add/list',
    method: 'get',
    params: query,
  })
}

// 获取机构算力详细信息
export function getOrgComputeInfo(orgId: any): any {
  return request({
    url: '/org/compute/getInfoByOrgId',
    method: 'get',
    params: { orgId },
  })
}

// 查询机构共享课时批次
export function getOrganizationLessonBalances(organizationId: any, silentError = false): any {
  return request({
    url: `/system/organization/${organizationId}/lessons/balances`,
    method: 'get',
    silentError,
  })
}

// 查询机构课时流水（包含发放和消课）
export function getOrganizationLessonLedger(organizationId: any, query: any): any {
  return request({
    url: `/system/organization/${organizationId}/lessons/ledger`,
    method: 'get',
    params: query,
  })
}
